module.exports = {
  localeName: 'en-NZ',
  momentFormat: 'DD/MM/YYYY'
};
